webpackJsonp([152176518627018],{

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BlogItems = undefined;
	
	var _background_ = __webpack_require__(25);
	
	var _background_2 = _interopRequireDefault(_background_);
	
	var _ChristianWenz = __webpack_require__(50);
	
	var _ChristianWenz2 = _interopRequireDefault(_ChristianWenz);
	
	var _LeifNixon = __webpack_require__(51);
	
	var _LeifNixon2 = _interopRequireDefault(_LeifNixon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogItems = exports.BlogItems = [{
		date: "13 March, 2020",
		title: "DevExperience 2020 is postponed for September/October 2020!",
		link: "/blog/conference-postponed/",
		text: "Due to national and international decisions and recommendations concerning public health our event is postponed for the autumn 2020.",
		showLeft: true,
		image: _background_2.default
	}, {
		date: "7 March, 2020",
		title: "Leif Nixon: Be curious and delight in how much there is to learn and invent!",
		link: "/blog/interview-leif-nixon/",
		text: "Founder and owner of Nixon Security, with an extensive experience of over 10 years in IT security in Linux-centric environments, Leif Nixon is a remarkable individual you absolutely need to meet.",
		showLeft: true,
		image: _LeifNixon2.default
	}, {
		date: "5 March, 2020",
		title: "Christian Wenz: I am exactly where the action is!",
		link: "/blog/interview-christian-wenz/",
		text: "Let`s get a quick glimpse at how our expert guest on security, Christian Wenz, will rock with Good Pressure this year`s edition of DevExperience.",
		showLeft: true,
		image: _ChristianWenz2.default
	}, {
		date: "25 February, 2020",
		title: "DevExperience 2020 - The one with The Good Pressure - Technology and meaning, for local impact",
		link: "/blog/the-good-pressure-edition/",
		text: "This year, we are determined to do even more good together at the fifth edition of DevExperience that will take place in Iași, between the 26th and 28th of March!",
		showLeft: true,
		image: _background_2.default
	}];

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/background_2020.9b904c68.png";

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _blogContent = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogEntry = function BlogEntry(props) {
		return _react2.default.createElement(
			'div',
			{ className: 'row' },
			_react2.default.createElement(
				'div',
				{ className: 'col-md-12 col-sm-12 wow fadeInUp' },
				_react2.default.createElement(
					'div',
					{ className: 'team-wrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						props.showLeft ? _react2.default.createElement(
							'div',
							{ className: 'col-md-2' },
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: props.link },
								_react2.default.createElement('img', { src: props.image, className: 'img-responsive' })
							)
						) : null,
						_react2.default.createElement(
							'div',
							{ className: 'col-md-10' },
							_react2.default.createElement(
								'h5',
								null,
								props.date
							),
							_react2.default.createElement(
								'h4',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: props.link },
									props.title
								)
							),
							_react2.default.createElement(
								'p',
								null,
								props.text
							),
							_react2.default.createElement(
								'p',
								null,
								'\xA0'
							)
						),
						!props.showLeft ? _react2.default.createElement(
							'div',
							{ className: 'col-md-2' },
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: props.link },
								_react2.default.createElement('img', { src: props.image, className: 'img-responsive' })
							)
						) : null,
						_react2.default.createElement(
							'p',
							null,
							'\xA0'
						)
					)
				)
			)
		);
	};
	
	var blogIndex = function blogIndex() {
		return _react2.default.createElement(
			'section',
			{ id: 'blog', className: 'parallax-section' },
			_react2.default.createElement(
				'div',
				{ className: 'container' },
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_blogContent.BlogItems.map(function (blog) {
					return _react2.default.createElement(BlogEntry, blog);
				})
			)
		);
	};
	exports.default = blogIndex;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-index-js-7d182e5f971c5b433428.js